import React from 'react';
import { TabsContent } from '../../ui/tabs';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Textarea } from '../../ui/textarea';
import { Button } from '../../ui/button';
import { Loader2, Send, ChevronDown, ChevronUp, Plus, Replace } from 'lucide-react';

const TextoTab = ({
  aiResponse,
  loading,
  hasText,
  selectedCommand,
  onCommandChange,
  textoCommands,
  showCustomMessage,
  onToggleCustomMessage,
  message,
  onMessageChange,
  onSend,
  onInsert,
  onReplace,
  onResponseChange,
  onResetResponse
}) => (
  <TabsContent value="texto" className="space-y-3">
    {!aiResponse ? (
      <>
        <div className="space-y-2">
          <label className="text-sm font-medium">Comando rápido</label>
          <Select value={selectedCommand} onValueChange={onCommandChange}>
            <SelectTrigger data-testid="quick-command-select">
              <SelectValue placeholder="Selecciona un comando..." />
            </SelectTrigger>
            <SelectContent>
              {textoCommands.map((cmd) => (
                <SelectItem key={cmd.id} value={cmd.id}>
                  {cmd.title}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <button
            onClick={onToggleCustomMessage}
            className="flex items-center gap-2 text-sm font-medium hover:text-sky-600 transition-colors"
          >
            {showCustomMessage ? (
              <ChevronUp className="w-4 h-4" />
            ) : (
              <ChevronDown className="w-4 h-4" />
            )}
            O escribe instrucción personalizada
          </button>

          {showCustomMessage && (
            <Textarea
              data-testid="quick-command-message"
              placeholder="Ej: Traduce al inglés..."
              value={message}
              onChange={(e) => onMessageChange(e.target.value)}
              rows={3}
              className="resize-none text-sm"
              disabled={loading}
            />
          )}
        </div>

        <Button
          data-testid="quick-send-button"
          onClick={onSend}
          disabled={loading || (!message && !selectedCommand) || !hasText}
          className="w-full bg-gradient-to-r from-sky-500 to-blue-600 hover:from-sky-600 hover:to-blue-700 text-white"
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Procesando...
            </>
          ) : (
            <>
              <Send className="w-4 h-4 mr-2" />
              Enviar a IA
            </>
          )}
        </Button>
      </>
    ) : (
      <>
        <div className="space-y-2">
          <label className="text-sm font-medium">Respuesta de IA (editable)</label>
          <Textarea
            data-testid="ai-response-text"
            value={aiResponse}
            onChange={(e) => onResponseChange(e.target.value)}
            rows={8}
            className="resize-none text-sm font-mono"
          />
        </div>

        <div className="flex gap-2">
          <Button
            data-testid="quick-insert-button"
            onClick={onInsert}
            className="flex-1 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white"
          >
            <Plus className="w-4 h-4 mr-2" />
            Insertar
          </Button>
          {hasText && (
            <Button
              data-testid="quick-replace-button"
              onClick={onReplace}
              className="flex-1 bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white"
            >
              <Replace className="w-4 h-4 mr-2" />
              Reemplazar
            </Button>
          )}
        </div>

        <Button
          variant="outline"
          onClick={onResetResponse}
          className="w-full"
        >
          ← Volver a editar
        </Button>
      </>
    )}
  </TabsContent>
);

export default TextoTab;
